import { colors, tabItem } from './styles'

interface Tab {
  readonly key: string
  readonly label: string
}

interface TabBarProps {
  readonly tabs: readonly Tab[]
  readonly activeTab: string
  readonly onTabChange: (key: string) => void
}

export function TabBar({ tabs, activeTab, onTabChange }: TabBarProps) {
  return (
    <div
      style={{
        display: 'flex',
        gap: '0',
        borderBottom: `1px solid ${colors.tabBorder}`,
        overflowX: 'auto',
        background: colors.bgCard,
      }}
    >
      {tabs.map((tab) => (
        <button key={tab.key} onClick={() => onTabChange(tab.key)} style={tabItem(activeTab === tab.key)}>
          {tab.label}
        </button>
      ))}
    </div>
  )
}
